"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.viewFromHash = viewFromHash;
exports.setupNavigation = setupNavigation;
function viewFromHash(hash) {
    if (hash === '#/puzzle')
        return 'puzzle';
    if (hash === '#/matching')
        return 'matching';
    return hash === '#/sketchpad' ? 'sketchpad' : 'balloons';
}
/** Hash navigation keeps one document and supports browser back/forward and deep links. */
function setupNavigation(show) {
    window.addEventListener('hashchange', () => show(viewFromHash(window.location.hash)));
    show(viewFromHash(window.location.hash));
}
//# sourceMappingURL=navigation.js.map